import { api } from './apiClient';

export const fetchChapterList = async (moduleId, page = 1, limit = 10, searchtext = '', filters = {}) => {
  // Validate moduleId is provided
  if (!moduleId) {
    throw new Error('Module ID is required to fetch chapters');
  }

  try {
    const requestBody = {
      page,
      limit,
      searchtext: searchtext || '',
      module_id: moduleId,
      filters: { ...filters, module_id: moduleId },
      pagination: {
        page,
        pageSize: limit,
        sort: { order: 1, _id: 1 },
        filters: { ...filters, module_id: moduleId },
      },
    };

    const response = await api.post('/api/v1/admin/chapters/list', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const createChapter = async (moduleId, chapterData) => {
  // Validate moduleId is provided
  if (!moduleId) {
    throw new Error('Module ID is required to create a chapter');
  }

  try {
    const requestBody = {
      module_id: moduleId,
      title: chapterData.title,
      description: chapterData.description,
      content: chapterData.content || chapterData.description || '',
      thumbnail_url: chapterData.thumbnail_url || '',
      order: chapterData.order || 1,
      early_access_days: Number.isInteger(Number(chapterData.early_access_days)) ? Number(chapterData.early_access_days) : 0,
    };

    const response = await api.post('/api/v1/admin/chapters', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const updateChapter = async (moduleId, chapterData) => {
  // Validate moduleId is provided (for frontend validation, not sent to API)
  if (!moduleId) {
    throw new Error('Module ID is required to update a chapter');
  }

  try {
    // Note: module_id is not included in update request body as the API doesn't allow it
    // The chapter_id is sufficient to identify which chapter to update
    const requestBody = {
      chapter_id: chapterData.chapter_id,
      title: chapterData.title,
      description: chapterData.description,
      content: chapterData.content || chapterData.description || '',
      thumbnail_url: chapterData.thumbnail_url || '',
      order: chapterData.order || 1,
      early_access_days: Number.isInteger(Number(chapterData.early_access_days)) ? Number(chapterData.early_access_days) : 0,
      is_active: chapterData.is_active !== undefined ? chapterData.is_active : true,
    };

    const response = await api.put('/api/v1/admin/chapters', requestBody);

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};

export const deleteChapter = async (moduleId, chapterId) => {
  // Validate moduleId is provided
  if (!moduleId) {
    throw new Error('Module ID is required to delete a chapter');
  }

  // Validate chapterId is provided
  if (!chapterId) {
    throw new Error('Chapter ID is required to delete a chapter');
  }

  try {
    // Include module_id as query parameter to ensure proper scoping
    const response = await api.delete(`/api/v1/admin/chapters/${chapterId}`, {
      params: {
        module_id: moduleId,
      },
    });

    return response.data;
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || `Server error: ${error.response.status}`;
      throw new Error(message);
    } else if (error.request) {
      throw new Error('Unable to reach the server. Please check your internet connection or try again later.');
    } else {
      throw new Error(error.message || 'An unexpected error occurred');
    }
  }
};


